import { Box, TextField, TextFieldProps } from '@mui/material';
import CustomLabel from 'components/common/CustomLabel/CustomLabel';
import CustomText from 'components/common/CustomText/CustomText';
import { useEffect } from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';
import { colors } from 'styles/colors';
import { customTextFieldSlotProps, customTextFieldSx } from 'styles/customTextFieldStyles';


type Props = {
  name: string;
  register: UseFormRegister<any>;
  error?: FieldError;
  placeholder?: string;
  label?: string;
  required?: boolean;
  note?: string;
  floatingLabel?: string;
} & Omit<TextFieldProps, 'name' | 'error' | 'helperText'>;

export default function CustomFormTextArea({
  name,
  register,
  error,
  placeholder,
  label,
  required,
  note,
  sx,
  floatingLabel,
  ...rest
}: Props) {
  return (
    <Box>
      {label && <CustomLabel
        label={label}
        note={note}
        required={required} />}
      <Box>
        <TextField
          {...register(name)}
          multiline
          minRows={4}
          maxRows={12}
          placeholder={placeholder}
          size="small"
          fullWidth
          label={floatingLabel}
          error={!!error}
          helperText={error?.message}
          slotProps={customTextFieldSlotProps}
          sx={{ ...customTextFieldSx, ...sx }}
          {...rest}
        />
      </Box>
    </Box>
  );
}
